import React from "react";
import { Check } from "lucide-react";
import { TRACK_STATUS, statusLabel, useLang } from "@/i18n";
import { fmtDateTime } from "@/lib/format";

export const StatusTimeline = ({ tracking = [] }) => {
  const { lang } = useLang();
  return (
    <div data-testid="status-timeline" className="space-y-0">
      {tracking.map((entry, i) => {
        const last = i === tracking.length - 1;
        return (
          <div key={i} className="flex gap-3">
            <div className="flex flex-col items-center">
              <div className={`h-7 w-7 rounded-full grid place-items-center shrink-0 ${last ? "bg-primary text-primary-foreground" : "bg-primary/15 text-primary"}`}>
                <Check className="h-4 w-4" />
              </div>
              {i < tracking.length - 1 && <div className="w-0.5 flex-1 bg-primary/25 my-1" />}
            </div>
            <div className={`pb-6 ${last ? "" : ""}`}>
              <p className="font-semibold text-sm leading-tight">
                {statusLabel(TRACK_STATUS, entry.status, lang)}
              </p>
              {entry.note && <p className="text-sm text-muted-foreground mt-0.5">{entry.note}</p>}
              <p className="text-xs text-muted-foreground font-mono mt-0.5">{fmtDateTime(entry.date, lang)}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};
